import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {"defaultBreakpoint":"sm","breakpoints":{"sm":530,"md":1025,"lg":Infinity}})
